export const ShareStakeIcon = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8417 2.43359L15.7583 4.61693C17.175 5.24193 17.175 6.27526 15.7583 6.90026L10.8417 9.08359C10.2833 9.33359 9.36666 9.33359 8.80833 9.08359L3.89166 6.90026C2.475 6.27526 2.475 5.24193 3.89166 4.61693L8.80833 2.43359C9.36666 2.18359 10.2833 2.18359 10.8417 2.43359Z"
        stroke="#AAB3D0"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 9.16797C2.5 9.86797 3.025 10.6763 3.66667 10.9596L9.325 13.4763C9.75833 13.668 10.25 13.668 10.675 13.4763L16.3333 10.9596C16.975 10.6763 17.5 9.86797 17.5 9.16797"
        stroke="#AAB3D0"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 13.332C2.5 14.107 2.95833 14.807 3.66667 15.1237L9.325 17.6404C9.75833 17.832 10.25 17.832 10.675 17.6404L16.3333 15.1237C17.0417 14.807 17.5 14.107 17.5 13.332"
        stroke="#AAB3D0"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
